import React, { useEffect, useState } from "react";
import abu from "./abo.module.css";
import imgi from "../../img/new/1.png";
import imgii from "../../img/new/2.png";
import imgiii from "../../img/new/3.png";
import imgiv from "../../img/new/4.png";
import imgv from "../../img/new/5.png";
import imgvi from "../../img/new/6.png";
import imgvii from "../../img/new/7.png";
import imgviii from "../../img/new/8.png";
import imgix from "../../img/new/9.png";
import imgx from "../../img/new/10.png";
import imgxi from "../../img/new/11.png";
import imgxii from "../../img/new/12.png";
import imgxiii from "../../img/new/13.png";
import imgxiv from "../../img/new/14.png";
import imgxv from "../../img/new/15.png";
import imgxvi from "../../img/new/16.png";
import imgI from "../../img/img5.png";
import imgII from "../../img/img23.png";
import imgIII from "../../img/img24.png";
import imgIv from "../../img/new/17.png";

import { AiFillLinkedin, AiOutlineMail } from "react-icons/ai";
import { getAllEmployees, imageUrl } from "../../Api/PostManApi";

const About = () => {
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const result = await getAllEmployees();
        setEmployees(result);
        console.log(result);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployees();
  }, []);

  // Default team members data
  const defaultTeamMembers = [
    {
      id: 1,
      name: "Felicia Akindurodoye",
      position: "Tech journalist",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgii,
    },
    {
      id: 2,
      name: "Olumofe Temitayo",
      position: "Tech journalist",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgiii,
    },
    {
      id: 3,
      name: "Hauwa Ali Abdul",
      position: "Tech journalist",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgIv,
    },
    {
      id: 4,
      name: "Pelumi Apantaku",
      position: "Managing director",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgiv,
    },
    {
      id: 5,
      name: "Moduopeoluwa Olalere",
      position: "Tech journalist",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgv,
    },
    {
      id: 6,
      name: "Yemi Olakitan",
      position: "General manager",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgvi,
    },
    {
      id: 7,
      name: "Ibukunoluwa Josephine bankole",
      position: "Head of content / Tech journalist",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgvii,
    },
    {
      id: 8,
      name: "Babalola Seun",
      position: "Head of marketing",
      about:
        "Felicia is a seasoned communications professional with vast experience in Africa's telecommunications and media sectors, dedicated to creating a platform that fosters communication and collaboration within the market.",
      img: imgviii,
    },
  ];

  const renderTeamMember = (member) => (
    <div className={abu.card} key={member.id}>
      <img
        src={`${imageUrl}/employee_images/${member.photo}`}
        alt={member.name}
      />
      <h4>{member.name}</h4>
      <span>{member.position}</span>
      <p>{member.about}</p>
      <div className={abu.icons}>
        <AiFillLinkedin />
        <AiOutlineMail />
      </div>
    </div>
  );

  return (
    <div className={abu.abu}>
      <div className={abu.container}>
        <div className={abu.content}>
          <div className={abu.blocki}>
            <div className={abu.seci}>
              <h2>
                Meet the team <br /> Behind <br />
                <span>Techpression</span>
              </h2>
              <p>
                We are a passionate team of writers and creators dedicated to
                bringing you fresh, engaging, and insightful content on a wide
                range of topics. Whether you're here for tips, inspiration, or
                simply to stay informed, our goal is to provide valuable
                information that resonates with you. From lifestyle and wellness
                to tech and trends, we strive to explore diverse subjects with
                authenticity and enthusiasm. Join us on this journey as we share
                stories, ideas, and experiences designed to inspire, educate,
                and entertain.
              </p>
            </div>
            <div className={abu.secii}>
              <img src={imgi} alt="" />
            </div>
          </div>

          <div className={abu.blockii}>
            <div className={abu.sub}>
              <h3>OUR TEAM</h3>
            </div>

            <div className={abu.flex}>
              {employees.length > 0
                ? employees.map(renderTeamMember)
                : defaultTeamMembers.map(renderTeamMember)}
            </div>

            <div className={abu.flexii}>
              <div className={abu.seciii}>
                <div className={abu.cardII}></div>

                <div className={abu.seciv}>
                  <h3>ADS POST</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Rest of your components remain the same */}
          <div className={abu.blockiii}>
            <div className={abu.flexiii}>
              <h4>Meet Our Partners</h4>
              <p>
                We have the support of the leading companies making an <br />
                impact on Africa's digital transformation.
              </p>
            </div>
            <div className={abu.flexiv}>
              <img src={imgix} alt="" />
              <img src={imgx} alt="" />
              <img src={imgxi} alt="" />
              <img src={imgxii} alt="" />
            </div>
          </div>

          <div className={abu.blockiii}>
            <div className={abu.flexiii}>
              <h4>Partner Events</h4>
              <p>
                We have the support of the leading companies making an <br />
                impact on Africa's digital transformation.
              </p>
            </div>
            <div className={abu.flexiv}>
              <img src={imgxiii} alt="" />
              <img src={imgxiv} alt="" />
              <img src={imgxv} alt="" />
              <img src={imgxvi} alt="" />
            </div>
            <div className={abu.btn}>
              <button>Request Partnership</button>
            </div>
          </div>

          <div className={abu.blockiv}>
            <div className={abu.edit}>
              <button>Editor's Choice</button>
            </div>
            <div className={abu.flexI}>
              <div className={abu.cardI}>
                <img src={imgI} alt="" />
                <div className={abu.secI}>
                  <h5>Cryptocurrency</h5>
                  <h5>Business</h5>
                  <h5>Startup</h5>
                </div>
                <p>Open AI empowers teacher with free training AI course</p>
              </div>
              <div className={abu.cardI}>
                <img src={imgII} alt="" />
                <div className={abu.secI}>
                  <h5>Cryptocurrency</h5>
                  <h5>Business</h5>
                  <h5>Startup</h5>
                </div>
                <p>
                  Hurupay offers Virtual USD Accounts with zero monthly fees for
                  freelancers, remote workers outside U.S.
                </p>
              </div>
              <div className={abu.cardI}>
                <img src={imgIII} alt="" />
                <div className={abu.secI}>
                  <h5>Cryptocurrency</h5>
                  <h5>Business</h5>
                  <h5>Startup</h5>
                </div>
                <p>
                  AfriGO, OPay's alliance to transform Nigeria's digital payment
                  ecosystem
                </p>
              </div>
            </div>
          </div>

          <div className={abu.blockv}>
            <div className={abu.cont}>
              <h2>Contact us</h2>
            </div>
            <div className={abu.para}>
              <p>
                We'd love to hear from you! Whether you have a question,
                feedback, or just want to share your thoughts, feel free to
                reach out to us. Our team is here to help and ensure you have
                the best experience on our blog. You can contact us through the
                form below, or email us directly at Techpression@gmail.com We
                value your input and strive to respond to all inquiries as
                quickly as possible. Thank you for visiting, and we look forward
                to connecting with you!
              </p>
              <div className={abu.secIi}>
                <div className={abu.genI}>
                  <h3>GENERAL ENQUIRES</h3>
                  <p>Email: info@techpression.com</p>
                  <h5>Pelumi Apantaku</h5>
                  <span>Managing director</span>
                </div>
                <ul>
                  <h3>SOCIAL MEDIA</h3>
                  <li>Instagram</li>
                  <li>youtube</li>
                  <li>Facebook</li>
                  <li>Twitter</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
